/* eslint react/prop-types: 0, react/display-name: 0 */
import * as React from "react"
import { PreviewStoreProvider } from "gatsby-source-prismic"

const wrapRootElement = ({ element }) => (
  <PreviewStoreProvider>{element}</PreviewStoreProvider>
)

export default wrapRootElement
